import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { profileData } from '../data/mock';

const SEOHead = () => {
  const { language } = useLanguage();

  const seoData = {
    en: {
      title: 'Ömer Karani Denizoglu | Software Developer & Entrepreneur',
      description: 'Ömer Karani Denizoglu - Founder & CEO of Karany Holding and Karany Web Solutions B.V. Software Developer specializing in modern web technologies, React, Node.js, and innovative digital solutions based in the Netherlands.'
    },
    nl: {
      title: 'Ömer Karani Denizoglu | Software Developer & Ondernemer',
      description: 'Ömer Karani Denizoglu - Oprichter & CEO van Karany Holding en Karany Web Solutions B.V. Software Developer gespecialiseerd in moderne webtechnologieën, React, Node.js en innovatieve digitale oplossingen in Nederland.'
    },
    tr: {
      title: 'Ömer Karani Denizoglu | Yazılım Geliştirici & Girişimci',
      description: 'Ömer Karani Denizoglu - Karany Holding ve Karany Web Solutions B.V. Kurucusu & CEO. Modern web teknolojileri, React, Node.js ve yenilikçi dijital çözümler konusunda uzmanlaşmış Yazılım Geliştirici. Hollanda merkezli.'
    }
  };

  const currentSEO = seoData[language] || seoData.en;

  useEffect(() => {
    // Update document title
    document.title = currentSEO.title;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = currentSEO.description;

    // Update lang attribute
    document.documentElement.lang = language;
  }, [language, currentSEO]);

  return null;
};

export default SEOHead;
